import {
  FETCH_TRANSACTION_REPORTS,
  FETCH_TRANSACTION_REPORTS_OFFSET,
  FETCH_TRANSACTION_REPORTS_TOTAL,
} from '../actions/types';

export default function transactionsReducer(state = { items: [] }, action) {
  switch (action.type) {
    case FETCH_TRANSACTION_REPORTS:
      return { ...state, transactions: action.payload };
    case FETCH_TRANSACTION_REPORTS_OFFSET:
      return { ...state, transactions: [...state.transactions, ...action.payload] };
    case FETCH_TRANSACTION_REPORTS_TOTAL:
      return { ...state, transactionsTotal: action.payload };
    default:
      return state;
  }
}